<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><strong>Eat Your Feelings</strong></h1>
<h1 class="subtitle">The <strong>FOOD MOOD GIRL’S</strong><br/><strong>GUIDE</strong> to <strong>TRANSFORMING<br/>YOUR EMOTIONAL EATING</strong></h1>
<h2 class="author"><strong>LINDSEY SMITH</strong></h2>
<p class="figure"><img alt="images" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?df4f98e4